import { useState } from "react";

/**
 * SmartImage — image with graceful editorial fallback.
 * If src fails to load, renders an elegant monogram block (no broken-image icon).
 * Uses React state — DOES NOT mutate outerHTML (which throws in React's reconciler).
 */
export default function SmartImage({
  src,
  alt = "",
  className = "",
  monogram = "A",
  fallbackLabel = "Photograph pending",
  loading = "lazy",
}) {
  const [errored, setErrored] = useState(false);

  if (errored || !src) {
    return (
      <div
        className={`w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-bone-200 to-sandstone ${className}`}
        role="img"
        aria-label={alt}
      >
        <div className="font-serif italic text-[120px] md:text-[140px] leading-none text-oxblood/25 select-none">
          {monogram}
        </div>
        <div className="mt-4 text-[10px] uppercase tracking-[0.32em] text-espresso-soft">
          {fallbackLabel}
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading={loading}
      onError={() => setErrored(true)}
      className={className}
    />
  );
}
